import { Remoting_buildProxy_64DC51C } from "./fable_modules/Fable.Remoting.Client.7.35.0/Remoting.fs.js";
import { RemotingModule_createApi, RemotingModule_withRouteBuilder } from "./fable_modules/Fable.Remoting.Client.7.35.0/Remoting.fs.js";
import { ITablePlannerApi_$reflection } from "./Shared/Types.js";

const api = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder((typeName, methodName) => (`/api/${typeName}/${methodName}`), RemotingModule_createApi()), ITablePlannerApi_$reflection());

export function login(req) {
    return api.login(req);
}

export function register(req) {
    return api.register(req);
}

export function me() {
    return api.me("");
}

export function getEvents() {
    return api.getEvents("");
}

export function getEvent(id) {
    return api.getEvent(id);
}

export function createEvent(req) {
    return api.createEvent(req);
}

export function updateEvent(req) {
    return api.updateEvent(req);
}

export function deleteEvent(id) {
    return api.deleteEvent(id);
}

export function getGuests(eventId) {
    return api.getGuests(eventId);
}

export function createGuest(req) {
    return api.createGuest(req);
}

export function updateGuest(req) {
    return api.updateGuest(req);
}

export function deleteGuest(id) {
    return api.deleteGuest(id);
}

export function importGuests(eventId, csv) {
    return api.importGuests([eventId, csv]);
}

export function updateGuestTags(req) {
    return api.updateGuestTags(req);
}

export function cloneGuestsFromEvent(req) {
    return api.cloneGuestsFromEvent(req);
}

export function getPairs(eventId) {
    return api.getPairs(eventId);
}

export function createPair(req) {
    return api.createPair(req);
}

export function deletePair(id) {
    return api.deletePair(id);
}

export function getFamilies(eventId) {
    return api.getFamilies(eventId);
}

export function createFamily(req) {
    return api.createFamily(req);
}

export function deleteFamily(id) {
    return api.deleteFamily(id);
}

export function getGroups(eventId) {
    return api.getGroups(eventId);
}

export function createGroup(req) {
    return api.createGroup(req);
}

export function deleteGroup(id) {
    return api.deleteGroup(id);
}

export function getTables(eventId) {
    return api.getTables(eventId);
}

export function createTable(req) {
    return api.createTable(req);
}

export function updateTable(req) {
    return api.updateTable(req);
}

export function updateTablePosition(req) {
    return api.updateTablePosition(req);
}

export function deleteTable(id) {
    return api.deleteTable(id);
}

export function getRules(eventId) {
    return api.getRules(eventId);
}

export function createRule(req) {
    return api.createRule(req);
}

export function deleteRule(id) {
    return api.deleteRule(id);
}

export function getWeights(eventId) {
    return api.getWeights(eventId);
}

export function saveWeights(args_, args__1) {
    return api.saveWeights([args_, args__1]);
}

export function arrange(req) {
    return api.arrange(req);
}

export function cancelArrange(eventId) {
    return api.cancelArrange(eventId);
}

export function getArrangements(eventId) {
    return api.getArrangements(eventId);
}

export function getArrangement(id) {
    return api.getArrangement(id);
}

export function selectArrangement(id) {
    return api.selectArrangement(id);
}

export function lockSeat(req) {
    return api.lockSeat(req);
}

export function unlockSeat(eventId, guestId) {
    return api.unlockSeat([eventId, guestId]);
}

export function likeArrangement(id) {
    return api.likeArrangement(id);
}

export function unlikeArrangement(id) {
    return api.unlikeArrangement(id);
}

export function setArrangementNotes(args_, args__1) {
    return api.setArrangementNotes([args_, args__1]);
}

export function rateArrangement(req) {
    return api.rateArrangement(req);
}

export function getArrangementFeedback(arrangementId) {
    return api.getArrangementFeedback(arrangementId);
}

export function updateProfile(req) {
    return api.updateProfile(req);
}

export function changePassword(req) {
    return api.changePassword(req);
}

export function deleteAccount() {
    return api.deleteAccount("");
}

export function getConnectedProviders() {
    return api.getConnectedProviders("");
}

export function hasPassword() {
    return api.hasPassword("");
}

export function getTags(eventId) {
    return api.getTags(eventId);
}

export function createTag(req) {
    return api.createTag(req);
}

export function updateTag(req) {
    return api.updateTag(req);
}

export function deleteTagById(id) {
    return api.deleteTag(id);
}

export function getTagGroupStrategies(eventId) {
    return api.getTagGroupStrategies(eventId);
}

export function saveTagGroupStrategies(req) {
    return api.saveTagGroupStrategies(req);
}

export function getRsvpConfig(eventId) {
    return api.getRsvpConfig(eventId);
}

export function saveRsvpConfig(req) {
    return api.saveRsvpConfig(req);
}

export function getRsvpSummary(eventId) {
    return api.getRsvpSummary(eventId);
}

export function getRsvpGuestLinks(eventId) {
    return api.getRsvpGuestLinks(eventId);
}

export function generateRsvpTokens(eventId) {
    return api.generateRsvpTokens(eventId);
}

export function getPublicLinks(eventId) {
    return api.getPublicLinks(eventId);
}

export function createPublicLink(req) {
    return api.createPublicLink(req);
}

export function updatePublicLink(req) {
    return api.updatePublicLink(req);
}

export function deletePublicLink(id) {
    return api.deletePublicLink(id);
}

export function getAuthMode() {
    return api.getAuthMode("");
}

export function getDebugUsers() {
    return api.getDebugUsers("");
}

export function debugLogin(userId) {
    return api.debugLogin(userId);
}

